/*
 * 作者: Fultom
 * 创建时间: 2021-03-02 15:59:00
 * 最近修改时间: 2023-03-23 10:28:25
 * 功能:
 */
import { ajaxFunc } from '../tools';

const activity = {
    // 获取年会门票信息
    ticket_info: ajaxFunc('/activity/getRevelryActivityInfo', 'get'),
    // 兑换门票
    exchange_ticket: ajaxFunc('/activity/exchangeRevelryActivity', 'post'),

    //2023-3 订货 活动排行
    sale_rank_data: ajaxFunc('/dataCenter/saleRankData', 'get'),
};

export default activity;



// WEBPACK FOOTER //
// ./src/request/api/activity.js